import {memo} from "react";


import {priceDigitSeperator} from "../../Utils/Helpers";

const Screen = (props) => {
    const data = props.location.state.result;

    return (
        <div className="container">
            <div className="mt-5">
                <img src={data?.business_logo} className="mx-auto d-block" width="100"/>
                <h3 className="text-center mt-4 font-weight-bold" dir="rtl">{data?.business_name}</h3>
                <h6 className="text-center text-muted mt-3" dir="rtl">{data?.description}</h6>
                {
                    data?.status ?
                        <div className="text-center text-white py-3 rounded h5 mb-3"
                             style={{background: "#66b73e",marginTop:"30px"}}>  ✓ تراکنش با موفقیت انجام شد.
                        </div>
                        :
                        <div className="text-center text-white py-3 rounded h5 mb-3 "
                             style={{background: "#dd3737",marginTop:"30px"}}>  ✕ تراکنش ناموفق
                        </div>
                }
                <div className="border px-2">
                    <div className="d-flex align-items-center justify-content-between p-3">
                        <img src={data.productImage} className="" width="100"/>
                        <h6 className="font-weight-bold">{data.productName}</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between border-top py-4 px-3">
                        <h6 className="font-weight-bold">مبلغ تراکنش:</h6>
                        <h6 className="font-weight-bold">{priceDigitSeperator(data?.amount || 0)} تومان</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between border-top py-4 px-3">
                        <h6 className="font-weight-bold">کد رهگیری:</h6>
                        <h6 className="font-weight-bold">{data?.tracking_code}</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between border-top py-4 px-3">
                        <h6 className="font-weight-bold">لینک سایت مرجع:</h6>
                        <h6 className="font-weight-bold"><a href={`https:${data?.link}`}>{data?.link}</a></h6>
                    </div>
                </div>
                <div className="d-block d-lg-flex justify-content-between px-4 mt-5 text-muted text-right">
                    <div className="d-flex justify-content-between">
                        <h6>تلفن پشتیبانی:</h6>
                        <h6 className="mr-2">{data?.tel}</h6>
                    </div>
                    <h6 className="mt-2 mt-lg-0">
                        کلیه حقوق مادی و معنوی این درگاه متعلق به داپ اپ می باشد.
                    </h6>
                </div>
            </div>
        </div>
    );
};
export default memo(Screen);